import { ExtensionMessage } from './models/extensionMessage.js';
import { ExtensionMessageType } from "./models/extensionMessageType.js";
import { RestClient } from './restClient.js';
export class Extensions {
  constructor(shop, basketId, imagineEnvironmentBaseUrl) {
    let authToken = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    let getNewAuthTokenFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
    let customRequestHeaders = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
    this.shop = shop;
    this.basketId = basketId;
    this.messageChannels = [];
    this.shop = shop;
    this.basketId = basketId;
    this.client = new RestClient(imagineEnvironmentBaseUrl, shop, authToken, getNewAuthTokenFunction, customRequestHeaders);
  }
  async invokeExtensions(extensionSubscriptions, iframe) {
    try {
      if (!iframe) {
        throw new Error('No valid iframe provided!');
      }
      if (extensionSubscriptions) {
        // See https://2ality.com/2016/10/asynchronous-iteration.html for docs on 'for-await-of'
        for await (const extensionSubscription of extensionSubscriptions) {
          await this.invokeExtension(extensionSubscription, iframe);
        }
      }
    } catch (e) {
      console.error(e.message, e);
    }
  }
  triggerEvent(eventId) {
    return this.getExtensionSubscriptionByEvent(eventId);
  }
  disposeMessageListeners() {
    if (this.messageChannels && this.messageChannels.length > 0) {
      this.messageChannels.forEach(messageChannel => {
        messageChannel.port1.close();
        messageChannel.port2.close();
      });
    }
  }
  async getExtensionSubscriptionByEvent(eventId) {
    try {
      return await this.client.get(`extension/extensionSubscriptions/${eventId}`);
    } catch (e) {
      console.error('Failed to get extension subscriptions by event', e);
      return new Promise(resolve => resolve([]));
    }
  }
  async putExtensionDataEntry(extensionDataEntry) {
    try {
      return await this.client.put('extension/extensionDataEntry', extensionDataEntry);
    } catch (e) {
      console.error('Failed to put extension data entry', e);
      return new Promise(resolve => resolve(null));
    }
  }
  getExtension(extensionSubscriptionId) {
    return this.client.get(`extension/${extensionSubscriptionId}/${this.basketId}`);
  }
  async invokeExtension(extensionSubscription, iframe) {
    try {
      const extension = await this.getExtension(extensionSubscription.id);
      const messageChannel = new MessageChannel();
      const extensionRunningPromise = new Promise(resolve => {
        this.messageChannels.push(messageChannel);
        messageChannel.port1.onmessage = event => {
          this.onMessageReceived(event.data, extension, resolve);
        };
      });
      iframe.addEventListener('load', function initiateHandshake() {
        var _a;
        const handshakeMessage = new ExtensionMessage(ExtensionMessageType.Handshake, extension.encryptedExtension);
        const targetOrigin = new URL(extension.url).origin;
        (_a = this.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(handshakeMessage, targetOrigin, [messageChannel.port2]);
      }, {
        once: true
      });
      iframe.src = extension === null || extension === void 0 ? void 0 : extension.url;
      iframe.title = extension === null || extension === void 0 ? void 0 : extension.name;
      return extensionRunningPromise;
    } catch (e) {
      console.error('Failed to invoke extension', e);
      return new Promise(resolve => resolve());
    }
  }
  onMessageReceived(message, extension, resolve) {
    try {
      switch (message.type) {
        case ExtensionMessageType.ExecutionComplete:
          this.extensionExecutionComplete(extension, message.encryptedPayload, resolve);
          break;
        default:
          throw new Error(`Unsupported message type ${message.type} received!`);
      }
    } catch (e) {
      console.error(e.message, e);
      this.disposeMessageListeners();
    }
  }
  async extensionExecutionComplete(extension, encryptedPayload, resolve) {
    {
      const extensionDataEntry = {
        basketId: this.basketId,
        extensionId: extension.id,
        eventId: extension.eventId,
        moduleAuthId: extension.moduleAuthId,
        shop: this.shop,
        encryptedData: encryptedPayload
      };
      await this.putExtensionDataEntry(extensionDataEntry);
      this.disposeMessageListeners();
      resolve();
    }
  }
}